import { render } from "./CardView.vue?vue&type=template&id=a015e5a2&ts=true"
import script from "./CardView.vue?vue&type=script&lang=ts"
export * from "./CardView.vue?vue&type=script&lang=ts"

import "./CardView.vue?vue&type=style&index=0&id=a015e5a2&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__